import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import Alert from '@mui/material/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DemoEditorError(props) {
  if (!props.children) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, _extends({
    "aria-live": "polite",
    variant: "filled",
    severity: "error",
    sx: {
      position: 'absolute',
      top: 0,
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
      py: '2px',
      px: '6px',
      '& .MuiAlert-icon': {
        fontSize: 14,
        mr: 0.5,
        mt: 0.25,
        py: 0
      },
      '& .MuiAlert-message': {
        fontSize: 12,
        py: 0
      }
    }
  }, props));
}